import * as React from 'react';
import { connect } from 'react-redux';
import {
    fetchPublicacion,
    editPublicacion,
    fetchTiposPublicacion,
    fetchVariaciones,
    fetchMotivosRevision,
    seModificaronImagenes
} from '../../../../actions/publicacionesActions';
import {
    deletePublicacionApi,
    updatePublicacionApi,
} from '../../../../api/axios';
import { fetchGarantias } from '../../../../actions/garantiasActions';
import { fetchRebate } from '../../../../actions/rebatesActions';
import { formatCurrencyToNumber } from '../../../../helper/publicacionHelper';
import DatosBasicos from './DatosBasicos';
import PrecioPago from './PrecioPago';
import Entrega from './Entrega';
import Imagenes from './Imagenes';
import Estado from './Estado';
import Garantia from './Garantia'
import Tab from '../../../General/Tab'
import ModalItem from '../../../General/Modal';
import BigSpinner from "../../../General/BigSpinner";
import MiniSpinner from "../../../General/MiniSpinner";
import { toast } from 'react-toastify';


class PublicacionEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0,
            showModal: false,
            tabs: [
                { name: "Datos Básicos ", icon: "ti-home", content: <DatosBasicos idSeller={this.props.match.params.idSeller} id={this.props.match.params.id} isEditing={true} /> },
                { name: "Precio y Medio de Pago", icon: "sl-icon-wallet", content: <PrecioPago id={this.props.match.params.id} /> },
                { name: "Entrega ", icon: "sl-icon-globe", content: <Entrega idSeller={this.props.match.params.idSeller} id={this.props.match.params.id} /> },
                { name: "Imagenes ", icon: "sl-icon-picture", content: <Imagenes idSeller={this.props.match.params.idSeller} id={this.props.match.params.id} /> },
                { name: "Estado ", icon: "sl-icon-layers", content: <Estado idSeller={this.props.match.params.idSeller} id={this.props.match.params.id} inCreate={false} return={this.goToPreviousPath} /> },
                { name: "Garantía ", icon: "ti-home", content: <Garantia idSeller={this.props.match.params.idSeller} id={this.props.match.params.id} isEditing={true} /> },
            ],
            isClicked: false
        };
    }

    componentDidMount() {
        this.props.fetchPublicacion(this.props.match.params.id, this.props.match.params.idSeller);
        const { idSellerPub, tieneRebate } = this.props.location.state;
        this.props.fetchTiposPublicacion(idSellerPub);
        this.props.fetchMotivosRevision();
        if (tieneRebate) {
            this.props.fetchRebate(this.props.match.params.id);
        }
    }
 
    onChangeActiveTab = (index) => {
        this.setState({ activeTab: index });
    }

    fixDimensionesInt = (publicacion) => {
        let dimensionFix = [];
        if (publicacion.dimensiones != undefined) {
            publicacion.dimensiones.map((obj, index) => {
                let alto = parseFloat(publicacion.dimensiones[index].alto);
                let ancho = parseFloat(publicacion.dimensiones[index].ancho);
                let peso = parseFloat(publicacion.dimensiones[index].peso);
                let profundidad = parseFloat(publicacion.dimensiones[index].profundidad);
                let dimension = { "alto": alto, "ancho": ancho, "peso": peso, "profundidad": profundidad };
                dimensionFix.push(dimension);
            })
        }

        let publicacionFix = { ...publicacion, dimensiones: dimensionFix }
        return publicacionFix;
    }

    onSubmit = (event) => {
        event.preventDefault();
        this.setState({ isClicked: true })

        let publicacionCopy = this.props.publicacion;
        let publicacion = { ...publicacionCopy };

        publicacion.precioLista = formatCurrencyToNumber(publicacion.precioLista);
        publicacion.precioPromocional = formatCurrencyToNumber(publicacion.precioPromocional);
        publicacion.idTipoPublicacion = parseInt(publicacion.idTipoPublicacion);
        publicacion.idMotivoRevision = parseInt(publicacion.idMotivoRevision);
        publicacion.garantiaFabrica = publicacion.garantiaFabrica ? publicacion.garantiaFabrica : 0;
        publicacion.garantiaExtActiva = publicacion.garantiaFabrica > 0;
        if (this.props.userType.isAdminMod || this.props.userType.isCategory) publicacion.estado = this.props.publicacion.estado;
        publicacion.userId = this.props.userId;
        let json_1 = JSON.stringify(publicacion);
        let publicacionSinImagenes = JSON.parse(json_1);
        delete publicacionSinImagenes.imagenes;

        let fixPublicacion = this.fixDimensionesInt(publicacionSinImagenes);
        if (publicacion.precioPromocional == publicacion.precioLista) {
            toast.error("El precio promocional no puede ser igual o mayor al precio de lista")
        }
        else {
            const req = updatePublicacionApi(fixPublicacion);
            req.then(res => {
                toast.success("Publicacion editada");
                this.goToPreviousPath();
            }).catch(err => {
                // (err.response.data.errores)
                //     ? err.response.data.errores.forEach(error => toast.error(error))
                //     : toast.error("No pudo editarse");
            }).finally(() => {
                this.setState({ isClicked: false })
            });
        }
        
    }

    onDelete = (event) => {
        if (event != null) event.preventDefault();
        this.setState({ isClicked: true })

        const req = deletePublicacionApi(this.props.publicacion.idPublicacion);
        req.then(res => {
            toast.success("Publicación eliminada");
            this.goToPreviousPath();
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("No pudo eliminarse");
        }).finally(() => {
            this.setState({ isClicked: false })
        });
    }

    //onAprobarPublicacion = () => {
    //    this.setState({ isClicked: true })

    //    let publicacion = this.props.publicacion;
    //    if (publicacion.estado == "pendiente_activacion") publicacion.estado = "activo";

    //    publicacion.precioLista = formatCurrencyToNumber(publicacion.precioLista);
    //    publicacion.precioPromocional = formatCurrencyToNumber(publicacion.precioPromocional);

    //    let fixPublicacion = this.fixDimensionesInt(publicacion);

    //    const reqAprobar = postAprobarPublicacionApi({ idPublicacion: this.props.publicacion.idPublicacion });
    //    reqAprobar.then(res => {
    //        toast.success("Publicación aprobada");
    //    }).catch(err => {
    //        (err.response.data.errores)
    //            ? err.response.data.errores.forEach(error => toast.error(error))
    //            : toast.error("No pudo aprobarse");
    //    });

    //    const reqUpdate = updatePublicacionApi(fixPublicacion);
    //    reqUpdate.then(res => {
    //        toast.success("Publicacion editada");
    //        this.goToPreviousPath();
    //    }).catch(err => {
    //        // (err.response.data.errores)
    //        //     ? err.response.data.errores.forEach(error => toast.error(error))
    //        //     : toast.error("No pudo editarse");
    //    }).finally(() => {
    //        this.setState({ isClicked: false })
    //    });
    //}

    //onDesaprobarPublicacion = () => {
    //    this.setState({ isClicked: true })

    //    let publicacionCopy = this.props.publicacion;
    //    let publicacion = { ...publicacionCopy };

    //    if (publicacion.estado == "pendiente_activacion") publicacion.estado = "activo";

    //    publicacion.precioLista = formatCurrencyToNumber(publicacion.precioLista);
    //    publicacion.precioPromocional = formatCurrencyToNumber(publicacion.precioPromocional);
    //    publicacion.idMotivoRevision = parseInt(publicacion.idMotivoRevision);

    //    let fixPublicacion = this.fixDimensionesInt(publicacion);

    //    const reqDesaprobar = postDesaprobarPublicacionApi({ IdPublicacion: this.props.publicacion.idPublicacion });

    //    reqDesaprobar.then(res => {
    //        toast.success("Publicación desaprobada");
    //    }).catch(err => {
    //        (err.response.data.errores)
    //            ? err.response.data.errores.forEach(error => toast.error(error))
    //            : toast.error("No pudo desaprobarse");
    //    });

    //    const req = updatePublicacionApi(fixPublicacion);
    //    req.then(res => {
    //        toast.success("Publicacion editada");
    //        this.goToPreviousPath();
    //    }).catch(err => {
    //        // (err.response.data.errores)
    //        //     ? err.response.data.errores.forEach(error => toast.error(error))
    //        //     : toast.error("No pudo editarse");
    //    }).finally(() => {
    //        this.setState({ isClicked: false })
    //    });
    //}

    redirectToSeller() {
        localStorage.removeItem("pagina");
        this.props.history.push(`/Sellers/Editar/${this.props.publicacion.idSeller}`);
    }

    //onCambiarEstadoAprobacion = (e) => {
    //    e.preventDefault();
    //    switch (this.props.publicacion.estado) {
    //        case "activo":
    //            this.onAprobarPublicacion();
    //            break;
    //        case "en_revision":
    //            // case "en_revision" || "pausada":
    //            this.onDesaprobarPublicacion();
    //            break;
    //        default:
    //            this.goToPreviousPath();
    //            break;
    //    }
    //}

    selectTipoPublicacion = (idTipoDefault) => {
        let publicacion = this.props.publicacion;
        if (this.props.tiposPublicacion != undefined) {
            this.props.tiposPublicacion.map((item) => {
                if (item.codigo == this.props.publicacion.idTipoPublicacion) {
                    publicacion["idTipoPublicacion"] = item.codigo;
                    return;
                }
            });

            let res = this.props.tiposPublicacion.find(tipo => tipo.codigo === this.props.publicacion.idTipoPublicacion);
            if (res == undefined) {
                publicacion["idTipoPublicacion"] = idTipoDefault;
            }
        }
    }

    goToPreviousPath = () => {
        const { pathReturn } = this.props.location.state;
        this.props.history.push(`${pathReturn}`);
    }


    render() {
        const { isCategory, isAdminMod } = this.props.userType;

        if (this.props.tiposPublicacion != undefined) {
            if (this.props.tiposPublicacion.length > 0) {
                this.selectTipoPublicacion(this.props.tiposPublicacion[0].codigo);
            }
        }

        let idP = localStorage.getItem("pId");
        let idPublicacion = "";
        idPublicacion = this.props.publicacion != undefined ? this.props.publicacion.idPublicacion : "";

        let loadingPublicaciones = false;
        if (idP == idPublicacion) {
            loadingPublicaciones = true;
        }

        return (
            <div className="col-12">
                {!loadingPublicaciones ? <BigSpinner /> :
                    <div className="card">
                        <div className="card-body p-b-0">

                            <h4 className="card-title">Editar Publicacion - {idPublicacion}</h4>

                            {(isCategory || isAdminMod) &&
                                <button className="btn btn-link card-subtitle" onClick={() => { this.redirectToSeller() }}>
                                    {this.props.publicacion.nombreSeller}
                                </button>
                            }

                            <ul className="nav nav-tabs customtab" role="tablist">
                                {
                                    this.state.tabs.map((tab, index) => {
                                        if (tab.name != undefined) {
                                            return <div key={index} onClick={() => { this.onChangeActiveTab(index) }}>
                                                <Tab
                                                    name={tab.name}
                                                    icon={tab.icon}
                                                    isActive={index === this.state.activeTab}
                                                />
                                            </div>
                                        }
                                    })
                                }
                            </ul>

                            <form className="form-horizontal form-material p-10">
                                <div className="tab-content">

                                    {this.state.tabs[this.state.activeTab].content}

                                    <div className="row align-items-center justify-content-center mb-3 text-center">

                                        <div className="col-12 col-sm-auto" hidden={!this.state.isClicked}>
                                            <MiniSpinner />
                                        </div>

                                        <button
                                            type="submit"
                                            onClick={(e) => this.onSubmit(e)}
                                            disabled={this.state.isClicked}
                                            className="btn btn-sm background-rojo-megatone waves-light col-auto mx-2"
                                        >
                                            Guardar
                                        </button>

                                        <ModalItem
                                            btnText="Eliminar"
                                            text="¿Desea eliminar esta publicación?"
                                            onDelete={this.onDelete}
                                            show={this.state.showModal}
                                            disabled={this.state.isClicked}
                                            btnStyle="btn btn-sm btn-grey col-auto mx-2"
                                        />

                                        <button
                                            onClick={this.goToPreviousPath}
                                            className="btn btn-sm btn-light waves-effect waves-light col-auto mx-2"
                                        >
                                            Cancelar
                                        </button>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                }
            </div>
        );
    }
}


const mapStateToProps = state => ({
    seller: state.sellers.seller,
    userType: state.general.userType,
    idTipoUsuario: state.general.tipoUsuario,
    publicacion: state.publicaciones.publicacion,
    emptyFiltro: state.general.limpiar,
    imagenModificada: state.publicaciones.seModificaronImagenes,
    tiposPublicacion: state.publicaciones.tiposPublicacion,
    garantias: state.publicaciones.garantias,
    userId: state.general.userId,
});

export default connect(mapStateToProps, {
    fetchPublicacion,
    fetchGarantias,
    editPublicacion,
    fetchTiposPublicacion,
    fetchVariaciones,
    fetchMotivosRevision,
    seModificaronImagenes,
    fetchRebate
})(PublicacionEdit);